// import LoaderSvg from '@booking-system/assets/images/svg/loader.svg?react'
import DEFAULTS from '@/defaults.ts'
import { useEffect } from 'react'
import {useNavigate, useSearchParams} from 'react-router-dom'

/**
 * AuthCallback component that performs an API call to check authentication
 * and redirects accordingly:
 * - On success: Redirects to the dashboard
 * - On failure: Redirects to the external login service
 *
 * This component extracts a token parameter from the URL and uses it for authentication.
 */
const AuthCallback = () => {
	const navigate = useNavigate()

	const [searchParams] = useSearchParams();
	const token = searchParams.get('token')

	useEffect(() => {
		if (token !== null) {
			window.location.href = `${DEFAULTS.APIUrl}/auth/callback/${token}`
		}
	}, [navigate, token])

	// Show a loading indicator while checking
	return (
		<div className="absolute inset-0 bg-white/90 flex items-center justify-center z-50">
			<div className="flex flex-col items-center">
				<div className="k-loading-mask">
					<div className="k-loading-image" />
					<div className="k-loading-color" />
					<div className="text-(--colourSky60) text-lg tracking-wider absolute w-[200px] text-center top-[calc(50%+45px)] left-[calc(50%-100px)]">
						Verifying authentication...
					</div>
				</div>
			</div>
		</div>
	)
}

export default AuthCallback
